import React, { Component } from 'react'
import { Tab, Tabs } from "react-bootstrap";
import CheckBoxField from '../Elements/CheckboxField';
import NeedHelp from '../Elements/NeedHelp';
import SubmitFeedRequest from '../Elements/SubmitFeedRequest';
import InputField from '../Elements/InputField';
import { createFeedAction } from '../../../../../../actions/addFeedActions';

class Bluesky extends Component {

    state = {
        hashtag: "",
        handle: "",
        moderation: false,
        error: false,
        errorMsg: "This field is required",
        errormsgHandle: "This field is required",
        handleError: false,
        filterType: "hashtag",
        loading: false
    }
    componentDidMount() {
        this.props.onFilterNameChange(this.state.filterType)
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError: false });
    onManuallyApproveChange = (value) => this.setState({ moderation: value });

    onSubmit = () => {
        const { handle, moderation, hashtag, filterType } = this.state
        const { navigation, feedInfo, hideAddfeed, wallId } = this.props

        if (filterType == 'handle' && handle.trim().length==0) {
            this.setState({ handleError: true });
        } else if (filterType == 'hashtag' && hashtag.trim().length==0) {
            this.setState({ error: true, errorMsg: "This field is required" });
        } else {
            const ftr = feedInfo?.[0]?.networkTab?.findIndex(f => f.feedtype === filterType) ?? null;
            const filterId = feedInfo[0]?.networkTab[ftr]?.filter;

            var obj = {
                wallId: wallId,
                networkId: 31,
                connetedAccount: 0,
                feedType: filterId,
                filter: filterId,
                hashtagCaption: 0,
                accountId: 0,
                hashtagIGTV: 0,
                onlyReels: 0,
                moderation: moderation,
                productId: 4
            }

            if (filterId == 1) {
                obj['feedText'] = handle?.split('@')?.join('')?.replace(/[\u202A-\u202E\u2066-\u2069\u200E\u200F]/g, '')
            } else if (filterId == 2) {
                obj['feedText'] = hashtag
            }

            this.setState({ error: false, handleError: false, loading: true });

            createFeedAction(obj, 31, (feedId) => {
                if (feedId) {
                    navigation(`/moderation/index/${wallId}`);
                    hideAddfeed();
                }
                this.setState({loading: false });
            })
        }
    }

    render() {
        const { hashtag, handle, moderation,errormsgHandle, error, handleError, filterType, loading, errorMsg } = this.state;
        return (
            <div className="row">
                <div className="col-md-12">
                    <div className="form-body create_feed_wt">
                        <div className="tabbable-tabdrop newRadio d-flex align-items-center justify-content-between flex-wrap feeds_details personalizePopup">
                            <Tabs defaultActiveKey={filterType} id="PinterestFeedTab" onSelect={(e) => this.setState({ filterType: e }, () =>{ this.props.onFilterNameChange(e); })} className="nav-tabs-line nav-tabs-bold w-100 tabDrop mb-3">
                                <Tab eventKey={'hashtag'} key={'hashtag'} className="nav-link className= p-0" title={<span>{'Hashtag'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-hashtag`}></i>
                                                </span>
                                            </div>
                                            <InputField name={"hashtag"} id='bluesky_hashtag' className={`autosearch mycheck form-control`} placeholder="Enter user hashtag" value={hashtag} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        
                                        {error ? <span id="feedsfield1error" className="errorMessage required">{errorMsg}</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_handle" />
                                        </div>
                                    </div>
                                </Tab>
                                <Tab eventKey={'handle'} key={'handle'} className="nav-link className= p-0" title={<span>{'Handle'}</span>}>
                                    <div className="form-group">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text">
                                                    <i className={`fas fa-at`}></i>
                                                </span>
                                            </div>
                                            <InputField name={"handle"} id='bluesky_handle' className={`autosearch mycheck form-control`} placeholder="Enter user handle" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                                        </div>
                                        {handleError ? <span id="feedsfield1error" className="errorMessage required">{errormsgHandle}</span> : null}
                                    </div>
                                    <div className="hideforBSearch">
                                        <div className="checkbox-inline">
                                            <CheckBoxField isChecked={moderation} onChangeHandler={(e) => this.onManuallyApproveChange(e.target.checked)} name={"moderation"} id="checkbox_user" />
                                        </div>
                                    </div>
                                </Tab>
                            </Tabs>
                            <div className="form-actions w-100">
                                <div className="f-between flex-wrap border-top pt-3 mt-4">
                                    <NeedHelp text={'Need help in adding feeds?'} videoUrl={''} supportLink={''} />
                                    <SubmitFeedRequest onSubmit={this.onSubmit} onBack={this.props.onBack} loading={loading} />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Bluesky